"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _ButtonVariant = require("./ButtonVariant");
var _ButtonColor = require("./ButtonColor");
var _ButtonSize = require("./ButtonSize");
var _tailwindMerge = require("tailwind-merge");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function mapBaseClasses(variant, color) {
  const classes = ['focus:outline-none', 'focus-visible:ring', 'focus-visible:ring-opacity-20', 'disabled:text-gray-500', 'font-semibold', 'border-2', 'border-transparent', 'border-solid', 'transition-colors', 'hover:no-underline'];

  // variant check
  const isContained = variant === _ButtonVariant.ButtonVariant.Contained;
  const isOutlined = variant === _ButtonVariant.ButtonVariant.Outlined;

  // color check
  const isPrimary = color === _ButtonColor.ButtonColor.Primary;
  const isSecondary = color === _ButtonColor.ButtonColor.Secondary;
  const isLight = color === _ButtonColor.ButtonColor.Light;
  const isPill = color === _ButtonColor.ButtonColor.Pill;
  if (isContained) {
    classes.push('disabled:bg-gray-200');
    if (isPrimary) {
      classes.push('hover:bg-yellow-600', 'focus:bg-yellow-600', 'bg-yellow-500', 'text-black');
    }
    if (isSecondary) {
      classes.push('hover:bg-gray-900', 'focus:bg-gray-900', 'text-white', 'bg-black');
    }
    if (isLight) {
      classes.push('hover:bg-gray-200', 'focus:bg-gray-200', 'text-black', 'bg-white');
    }
    if (isPill) {
      classes.push('hover:bg-white', 'focus:bg-white', 'hover:border-black', 'text-black', 'bg-gray-200');
    }
  }
  if (isOutlined) {
    classes.push('disabled:border-gray-200');
    if (isPrimary) {
      classes.push('hover:text-black', 'hover:bg-yellow-500', 'focus:text-black', 'focus:bg-yellow-500', 'text-yellow-500', 'border-yellow-500');
    }
    if (isSecondary) {
      classes.push('hover:text-white', 'hover:bg-black', 'focus:text-white', 'focus:bg-black', 'text-black', 'border-black');
    }
    if (isLight) {
      classes.push('hover:text-black', 'hover:bg-white', 'focus:text-black', 'focus:bg-white', 'text-white', 'border-white');
    }
    if (isPill) {
      classes.push('hover:bg-gray-200', 'text-black', 'border-black');
    }
  }

  // focus ring color
  if (isPrimary) {
    classes.push('focus-visible:ring-yellow-500');
  }
  if (isSecondary) {
    classes.push('focus-visible:ring-gray-500');
  }
  if (isLight) {
    classes.push('focus-visible:ring-white');
  }
  if (isPill) {
    classes.push('focus-visible:ring-gray-200');
  }
  return classes;
}
function mapSizeClasses(size) {
  if (size === _ButtonSize.ButtonSize.Small) {
    return 'px-8 py-1.5 text-sm leading-4';
  }
  if (size === _ButtonSize.ButtonSize.Large) {
    return 'py-2.5 px-16 leading-6';
  }
  return 'px-8 py-1.5 leading-6';
}
var _default = /*#__PURE__*/(0, _react.forwardRef)(function Button(props, ref) {
  const {
    className,
    color = _ButtonColor.ButtonColor.Primary,
    fullWidth = false,
    size = _ButtonSize.ButtonSize.Medium,
    squared = false,
    variant = _ButtonVariant.ButtonVariant.Contained,
    children,
    ...rest
  } = props;
  const classes = (0, _tailwindMerge.twMerge)(...mapBaseClasses(variant, color), mapSizeClasses(size), squared ? 'rounded' : 'rounded-full', fullWidth && 'block w-full', className);
  if (props.href) {
    return /*#__PURE__*/_react.default.createElement("a", (0, _extends2.default)({}, rest, {
      ref: ref,
      className: classes
    }), children);
  }
  return /*#__PURE__*/_react.default.createElement("button", (0, _extends2.default)({}, rest, {
    ref: ref,
    className: classes
  }), children);
});
exports.default = _default;